import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_OFFICER_IN_INCIDENT = gql`
  mutation addOrUpdateOfficerInIncident(
    $input: AddOrUpdateOfficerInIncidentInput!
  ) {
    addOrUpdateOfficerInIncident(input: $input) {
      clientMutationId
      errors
      incidentUuid
      officerIncidentSpecificUuid
      officerIncidentSpecific {
        __typename
        arrivedAtHospitalAt
        clearedAt
        currentOfficerStatus
        dispatchedAt
        enrouteAt
        enrouteToHospitalAt
        fieldCheck
        id
        incidentId
        lastContactedAt
        logCodeId
        logCode {
          id
          name
        }
        officer {
          __typename
          id
          deptAttribute {
            __typename
            assignment
            badge
            carNumber
            id
            lastContactedAt
            notes
            ori {
              id
              abbreviation
              oriName
              municipalityNumber
            }
            radioNumber
            secondaryAddress
            skillsList
            status
          }
        }
        onSceneAt
        primaryOfficer
        secondaryAddress
        statusId
      }
    }
  }
`;
